import React from "react";
import LegalPage from "./LegalPage";

export default function Terms() {
  return (
    <LegalPage title="Terms & Conditions">
      <p>
        By using the Knight Insurance Solutions website you agree to these terms. The
        information on this site is provided for general informational purposes only and
        does not constitute an offer of insurance.
      </p>
      <h2 className="text-xl font-semibold text-slate-900 mt-8">Quotes &amp; policies</h2>
      <p>
        All quotes are estimates based on information you provide. Final premiums,
        coverage, and policy terms are determined by the issuing carrier and subject to
        underwriting approval.
      </p>
      <h2 className="text-xl font-semibold text-slate-900 mt-8">No warranty</h2>
      <p>
        Content on this site is provided on an &ldquo;as is&rdquo; basis without
        warranties of any kind. Knight Insurance Solutions is not liable for any errors
        or omissions in the content.
      </p>
      <h2 className="text-xl font-semibold text-slate-900 mt-8">Contact</h2>
      <p>
        Questions about these terms? Email{" "}
        <a className="underline" href="mailto:damon.knight@knightinssolutions.com">
          damon.knight@knightinssolutions.com
        </a>
        .
      </p>
    </LegalPage>
  );
}
